"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleParticipant = exports.copyParticipants = exports.addParticipants = exports.parseAndValidate = exports.removeParticipants = exports.fetchParticipants = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bid/participants");
const Actions = require("../../actions/bid/participants");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
const validation_1 = require("../../utils/validation");
function fetchParticipants(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant`
    }).pipe((0, operators_1.mergeMap)((xhr) => t
        .array(sok_types_1.Bid.iParticipant)
        .decode(xhr.response)
        .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error))), (groups) => (0, rxjs_1.of)(Actions.fetchSuccess(groups)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchParticipants = fetchParticipants;
function removeParticipants(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        body: action.payload.users.map((user) => ({
            user: user.id,
            group: action.payload.group.id
        })),
        method: 'DELETE',
        url: `${baseUrl}api/project/${action.payload.bid.project}/members`
    }).pipe((0, operators_1.mergeMap)((_xhr) => (0, rxjs_1.of)(Actions.removeSuccess(action.payload.users), Actions.fetchRequest(action.payload.bid))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.removeFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.removeParticipants = removeParticipants;
const parseAndValidate = (action) => action.payload.invitations.reduce((res, row) => {
    const emails = row.emails.split(',').filter((i) => i.trim().length > 0);
    const group = (0, validation_1.ap)((0, validation_1.hasInvalidValue)(row.uuid, [-2])(row.group));
    emails.forEach((e) => {
        const email = e.trim();
        group((0, validation_1.isEmail)(email)(email)).fold((err) => {
            const items = res.errors[row.uuid];
            if (!items) {
                res.errors[row.uuid] = err;
            }
            else {
                res.errors[row.uuid] = items.concat(err);
            }
        }, (_) => {
            var _a;
            res.invitations.push({
                groupId: row.group,
                email: email.trim(),
                language: (_a = row.language) !== null && _a !== void 0 ? _a : 'multi'
            });
        });
    });
    return res;
}, { errors: {}, invitations: [] });
exports.parseAndValidate = parseAndValidate;
function addParticipants(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ADD_PARTICIPANTS_REQUEST), (0, operators_1.mergeMap)((action) => {
        const data = (0, exports.parseAndValidate)(action);
        if (Object.keys(data.errors).length > 0) {
            return (0, rxjs_1.of)(Actions.addParticipantsValidation(data.errors));
        }
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            url: `${baseUrl}api/user-group/member`,
            body: data.invitations
        }).pipe((0, operators_1.mergeMap)((_) => {
            const act = [
                Actions.addParticipantsSuccess(),
                Actions.fetchRequest(action.payload.bid)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.addParticipantsFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.addParticipants = addParticipants;
function copyParticipants(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.COPY_PARTICIPANT), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/bid/${action.payload.selectedBid.id}/participant`
    }).pipe((0, operators_1.mergeMap)(({ response }) => t
        .array(sok_types_1.Bid.iParticipant)
        .decode(response)
        .fold((error) => (0, rxjs_1.throwError)(error), (participants) => (0, rxjs_1.of)(participants.map(({ user }) => user)))), (0, operators_1.map)((users) => users.map((user) => ({
        email: user.email,
        groupId: action.payload.targetGroup.id
    }))), (0, operators_1.mergeMap)((body) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/user-group/member`,
        body: body
    }).pipe((0, operators_1.mergeMap)((_) => {
        const acts = [
            (0, rxjs_1.of)(Actions.copyParticipantsSuccess(), Actions.fetchRequest(action.payload.targetBid)),
            (0, rxjs_1.of)(Actions.toggleCopyParticipant(false)).pipe((0, operators_1.delay)(2000))
        ];
        return (0, rxjs_1.merge)(...acts);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.copyParticipantsFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))))));
}
exports.copyParticipants = copyParticipants;
function toggleParticipant(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.TOGGLE_USER_FROM_GROUP), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/user-group/${action.state.toLowerCase()}`,
        body: action.payload.map((x) => ({
            userId: x.user.id,
            groupId: x.groupId,
            message: x.message
        }))
    }).pipe((0, operators_1.mergeMap)((response) => {
        const currentBid = store.value.bid.current.bid;
        if (response.status === 200) {
            const acts = [
                Actions.toggleUserFromGroupSuccess()
            ];
            if (currentBid) {
                acts.push(Actions.fetchRequest(currentBid));
            }
            return (0, rxjs_1.of)(...acts);
        }
        return (0, rxjs_1.of)(Actions.toggleUserFromGroupFailure((0, errorHandling_1.parseAjaxErrorResponse)(response.response)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.toggleUserFromGroupFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.toggleParticipant = toggleParticipant;
//# sourceMappingURL=participants.js.map